import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import z from "zod";
import { assetInstanceQueryOptions } from "@/services/asset";

/**
 * Thin Asset instance layout — shared params / soft prefetch for drawer tabs.
 * Drawer chrome lives in the pathless `_drawer` layout.
 */
export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/workspace/assets/$assetId",
)({
	params: {
		parse: (params) => ({
			assetId: z.string().parse(params.assetId),
		}),
	},
	beforeLoad: ({ location, params }) => {
		const normalized = location.pathname.replace(/\/$/, "");
		const exactRoot = normalized.endsWith(
			`/workspace/assets/${params.assetId}`,
		);
		if (exactRoot) {
			const q =
				typeof location.search === "object" &&
				location.search &&
				"q" in location.search &&
				typeof (location.search as { q?: unknown }).q === "string"
					? (location.search as { q: string }).q
					: undefined;
			throw redirect({
				to: "/web/$orgId/jobs/$jobId/workspace/assets/$assetId/details",
				params: {
					orgId: params.orgId,
					jobId: params.jobId,
					assetId: params.assetId,
				},
				search: { q },
			});
		}
	},
	loader: ({ context, params }) => {
		void context.queryClient.prefetchQuery(
			assetInstanceQueryOptions.detail(params.assetId, {
				organizationId: params.orgId,
			}),
		);
	},
	component: AssetIdLayout,
});

function AssetIdLayout() {
	return <Outlet />;
}
